import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView } from '@cer/cer-form/cer-form-view';

export class ProductFormForm extends CerFormAdapter {

  override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'formater', dataApiName: 'ProductForm', text: 'Formater, udgivelser', textSingular: "Format",
        primaryKey: 'num', baseFields: ['id', 'num', 'name', 'sorting', 'history']
      }, fieldMetadata: [
        { name: 'productType', fieldType: 'productType'  },
        { name: 'onix', text: 'ONIX' },
      ]
    });
  }
}
